import { render, staticRenderFns } from "./EntityTable.vue?vue&type=template&id=0062bd5c"
import script from "./EntityTable.vue?vue&type=script&lang=ts"
export * from "./EntityTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports